/* eslint @typescript-eslint/no-duplicate-enum-values: off */

import { LanguageAvailabilityByProduct } from '../shared/Enums';
// Re-export so we don't have to update a ton of old imports from this file
export {
    LanguageAvailabilityByProduct,
    LanguageContextType
} from '../shared/Enums';
export enum AssessmentType {
    Behavioral,
    Cognitive,
    Job,
    BulkAssessmentUpload,
    StrategyAssessment
}

export enum BehavioralAssessmentStatus {
    Unknown = 0,
    Pending = 1,
    Processing = 2,
    Completed = 3
}

// This is to be synced with Server Type
// See PublicIdentifiers.cs - EmailTypes - in Core.Common
export enum GlobalEmailTypes {
    BehavioralAssessmentEmail = 1,
    JobAssessmentEmail = 2,
    BehavioralAssessmentResultsEmail = 3,
    JobAssessmentResultEmail = 4,
    InterviewGuide = 5,
    CoachingGuide = 6,
    BehavioralReport = 7,
    JobReport = 8,
    PatternPlacard = 9,
    PersonalDevelopmentChart = 10,
    CognitiveAssessmentEmail = 11,
    ManagerDevelopmentChart = 12,
    ManagementStrategyGuide = 13,
    StrategyAssessmentEmail = 14,
    JobTargetReport = 15,
    InspireInvite = 16
}

// This is to be synced with the Server
export enum SurveyUserTypes {
    Unknown = 1,
    Other = 2,
    Candidate = 3,
    Employee = 4,
    FormerEmployee = 5,
    EmployeeAndCandidate = 6,
    Prospect = 7
}

export enum AssessmentApiProblems {
    SettingTypeAndJob,
    SendingBehavioral,
    SendingCognitive,
    SettingDefaultFolder,
    SendingCognitveAndBehavior
}

export enum SearchResultType {
    Person,
    Job
}

/**
 * The type of reference pattern. Numbering is off because it is based off of
 * the database.
 *
 * TODO: probably should be PatternReferenceType
 *
 * @deprecated Use ReferenceProfileType instead
 */
export enum PatternType {
    Adapter = 0,
    Venturer = 8,
    SciPro = 10,
    CreativeAnalytical = 12,
    Control = 14,
    Specialist = 20,
    Scholar = 22,
    Individualist = 24,
    Authoritative = 26,
    Maverick = 30,
    Persuasive = 36,
    AltruisticService = 46,
    SocialInterest = 54,
    Promotional = 56,
    Diligence = 60,
    Operational = 64,
    Artisan = 70
}

/**
 * The type of reference pattern associated with the database.
 */
export enum ReferenceProfileType {
    Adapter = 0,
    Altruist = 46,
    Analyzer = 12,
    Artisan = 70,
    Captain = 26,
    Collaborator = 54,
    Controller = 14,
    Guardian = 60,
    Individualist = 24,
    Maverick = 30,
    Operator = 64,
    Persuader = 36,
    Promoter = 56,
    Scholar = 22,
    Specialist = 20,
    Strategist = 10,
    Venturer = 8
}

// This matches the server, there is also a PiPatternGraphType that is slightly
// different so be WARNED!!!!
export enum ScoreInfoType {
    Self = 0,
    SelfConcept = 1,
    Synthesis = 2,
    Position = 3
}

// Matches the server. !!! Keep it synced !!!
// Code also relies on higher numbers having greater privileges
// DO NOT Violate this without updating hasPermissionLevelOrGreater
export enum RoleType {
    AbacUser = -1,
    ReadOnly = 0,
    SurveyAdminPIOnly = 1,
    SurveyAdminPIAndPRO = 2,
    User = 3,
    PowerUser = 4,
    AccountAdmin = 5,
    AccountOwner = 6,
    SuperAdmin = 7
}

// Keep this in sync with Enum ABOVE, hence the placement right below
export const RoleKeys: RoleKey = Object.freeze({
    [RoleType.AbacUser]: { translationKey: 'text.role.AbacUser' },
    [RoleType.ReadOnly]: { translationKey: 'text.role.ReadOnly' },

    [RoleType.SurveyAdminPIOnly]: {
        translationKey: 'text.role.SurveyAdminPi'
    },
    [RoleType.SurveyAdminPIAndPRO]: {
        translationKey: 'text.role.SurveyAdminPiPro'
    },
    [RoleType.User]: { translationKey: 'text.role.User' },

    [RoleType.PowerUser]: { translationKey: 'text.role.PowerUser' },
    [RoleType.AccountAdmin]: { translationKey: 'text.role.AccountAdmin' },
    [RoleType.AccountOwner]: { translationKey: 'RoleAccountOwner' },
    [RoleType.SuperAdmin]: { translationKey: 'text.role.SuperAdmin' }
});

export type RoleKey = {
    [key: string]: {
        translationKey: string;
    };
};

export enum SendAssessmentFlowType {
    Sent,
    Send,
    // This is effectively the old "Remind" enum
    SendAgainPending,
    SendAgainExpired
}

// NOTE: Copied from server
export enum ScoringMethodType {
    /// <summary>
    /// The scoring method was not defined
    /// </summary>
    Unknown = 0,
    /// <summary>
    /// The scoring method was via an email invitation
    /// </summary>
    EmailInvitation = 1,
    /// <summary>
    /// The scoring method was via an checklist
    /// </summary>
    Checklist = 2,
    /// <summary>
    /// The scoring method was via an open invitation
    /// </summary>
    OpenInvitation = 3,
    /// <summary>
    /// The scoring method was via a datasheet
    /// </summary>
    Datasheet = 4,

    CombinedPattern = 5
}

export enum SortType {
    RecentlySent = 1,
    RecentlyCompleted,
    Name,
    LastUpdated,
    Link,
    PersonType,
    ReferenceProfile,
    SentDate,
    RecentlyModifiedJob,
    AssociatedJob,
    Favorite,
    Folder,
    MatchScoreBehavioral,
    MatchScoreCognitive,
    MatchScoreOverall,
    Email,
    Role,
    Access,
    CreatedDate,
    CognitiveScore,
    FirstName
}

export enum SortDirection {
    // Wait, should this 1, -1 be switched - if you know, erase this comment
    Ascending = 1,
    Descending = -1
}

// NOTE: Copied from backend
export enum Impression {
    Favorite = 0,
    Unset = 1,
    Rejected = 2
}

// NOTE: Copied from Back End
export enum ExternalAssessmentStates {
    Unknown = -1,
    Pending = 10,
    AvailableEmailSent = 15,
    AvailableWebHookCalled = 17,
    AvailableMarked = 20,
    AvailableWebHookCompleted = 25,
    Started = 30,
    Completed = 40,
    CompleteEmailSent = 42,
    AssessmentCompleteWebHookCalled = 44,
    AssessmentCompleteEmailReceived = 45,
    AssessmentCompleteWebHookComplete = 46,
    Expired = 50,
    Failed = 60,
    Aborted = 65
}

// This Gender enum does not align with the gender enums used in the backend.  At some point in the future this
// should be removed and and usages should be replaced with the proper Gender enum that aligns with gender in the
// backend APIs - thervey - 5/29/2020
export enum LegacyGender {
    Unknown = 1,
    Male = 2,
    Female = 3
}

// For work going forward (5/29/2020) this Gender Enum should be used as it aligns with the backend API gender enum
export enum Gender {
    Unknown = 0,
    Male = 1,
    Female = 2
}

// Copied from Back End
export enum PiReportStyle {
    ManagementStyle,
    InfluencingStyle,
    SellingStyle
}

export enum SendEmailTo {
    AssessmentTaker,
    EmailSender
}

/*
The ReportType has so many possible null because it was constructed from a series of switch statements,
many of which did not have values for every report type. Hopefully the ReportType will get filled out
more in the future to allow more generic manipulation of reports.
*/
export type ReportTypeType = {
    serverValue?: PiReports;
    languages: LanguageAvailabilityByProduct;
    canEmail: boolean;
    viewButtonText?: string;
    emailButtonText?: string;
    emailType?: GlobalEmailTypes;
    reportName?: string;
    reportFilename?: string;
    endpoint?: string;
    endpointVersion?: string;
    requireGender?: boolean; // onboarding also implicitly has this information
    showSendAssessmentTakers?: boolean;
    showSendStakeholders?: boolean;
};

// This enum should be synced with the available reports from the backend as well (AssessmentReportType enum in backend).
export enum PiReports {
    Unknown = 0,
    BehavioralReport = 1,
    PersonalDevelopmentChart = 2,
    Placard = 3,
    ManagerDevelopmentChart = 4,
    ManagementStrategyGuide = 5,
    PersonSnapshot = 8,
    BehavioralOverview = 9,
    InterviewGuide = 10,
    CoachingGuide = 11,
    RelationshipGuide = 12,
    FullBehavioralPattern = 14
}

export const ReportType = {
    // Behavioral
    PiReport: {
        serverValue: PiReports.BehavioralReport,
        languages: LanguageAvailabilityByProduct.BehavioralReports,
        viewButtonText: 'text.common-terms.view.reports',
        emailButtonText:
            'personDashboard-behavioralReport.emailBehavioralReports',
        emailType: GlobalEmailTypes.BehavioralReport,
        reportName: 'label.common-terms.pi.report',
        reportFilename: 'reportName.pdf.behavioral',
        endpoint: 'EmailBAReports',
        canEmail: true,
        requireGender: true,
        showSendAssessmentTakers: true
    },
    ProReport: {
        languages: LanguageAvailabilityByProduct.JobReports,
        canEmail: true
    },
    InterviewGuide: {
        serverValue: PiReports.InterviewGuide,
        languages: LanguageAvailabilityByProduct.Guides,
        viewButtonText: 'interviewCandidates.emailViewButton',
        emailButtonText: 'interviewCandidates.emailSendButton',
        emailType: GlobalEmailTypes.InterviewGuide,
        reportName: 'label.common-terms.interview.guide',
        reportFilename: 'reportName.pdf.interviewGuide',
        canEmail: true,
        showSendAssessmentTakers: false,
        showSendStakeholders: false
    },
    CoachingGuide: {
        serverValue: PiReports.CoachingGuide,
        languages: LanguageAvailabilityByProduct.Guides,
        reportFilename: 'reportName.pdf.coachingGuide',
        canEmail: true,
        showSendAssessmentTakers: false,
        showSendStakeholders: false
    },
    Placard: {
        serverValue: PiReports.Placard,
        languages: LanguageAvailabilityByProduct.Placard,
        viewButtonText: 'text.common-terms.view.placards',
        emailButtonText: 'personDashboard-placard.emailPlacards',
        emailType: GlobalEmailTypes.PatternPlacard,
        reportName: 'common.placard',
        reportFilename: 'reportName.pdf.placard',
        endpoint: 'EmailPlacards',
        canEmail: true,
        showSendAssessmentTakers: true,
        showSendStakeholders: false
    },
    PersonalDevelopmentChart: {
        serverValue: PiReports.PersonalDevelopmentChart,
        languages: LanguageAvailabilityByProduct.PDC,
        viewButtonText: 'text.common-terms.view.personalDevelopmentChart',
        emailButtonText: 'personDashboard-pdc.emailPersonalDevelopmentChart',
        emailType: GlobalEmailTypes.PersonalDevelopmentChart,
        reportName: 'label.common-terms.personal.development.chart',
        reportFilename: 'reportName.pdf.personalDevelopmentChart',
        endpoint: 'EmailPDCs',
        canEmail: true,
        showSendAssessmentTakers: true,
        showSendStakeholders: false
    },
    CognitiveReport: {
        languages: LanguageAvailabilityByProduct.CognitiveReports,
        viewButtonText: 'text.common-terms.view.cognitiveReport',
        emailButtonText: 'personDashboard-cognitiveReport.emailCognitiveReport',
        reportName: 'CognitiveReport',
        reportFilename: 'reportName.pdf.cognitive',
        canEmail: true,
        showSendAssessmentTakers: false,
        showSendStakeholders: false
    },
    ManagerDevelopmentChart: {
        serverValue: PiReports.ManagerDevelopmentChart,
        languages: LanguageAvailabilityByProduct.PDC,
        reportName: 'managerDevelopmentChart.pdfTitle',
        reportFilename: 'reportName.pdf.managerDevelopmentChart',
        endpoint: 'EmailMDCs',
        viewButtonText: 'managerDevelopmentChart.view',
        emailButtonText: 'managerDevelopmentChart.email',
        emailType: GlobalEmailTypes.ManagerDevelopmentChart,
        canEmail: true,
        showSendAssessmentTakers: true,
        showSendStakeholders: false
    },
    ManagerStrategyGuide: {
        serverValue: PiReports.ManagementStrategyGuide,
        languages: LanguageAvailabilityByProduct.PDC,
        reportName: 'managerStrategyGuide.pdfTitle',
        reportFilename: 'reportName.pdf.managementStrategyGuide',
        endpoint: 'EmailMSGs',
        viewButtonText: 'managerStrategyGuide.view',
        emailButtonText: 'managerStrategyGuide.email',
        emailType: GlobalEmailTypes.ManagementStrategyGuide,
        canEmail: true,
        showSendAssessmentTakers: true,
        showSendStakeholders: false
    },
    JobReport: {
        languages: LanguageAvailabilityByProduct.JobReports,
        viewButtonText: 'text.common-terms.view.pro.report',
        emailButtonText: 'jobDashboard-jobReport.emailJobReports',
        emailType: GlobalEmailTypes.JobReport,
        reportName: 'label.common-terms.pro.report',
        endpoint: 'EmailJobTargetReports',
        canEmail: true,
        showSendAssessmentTakers: false,
        showSendStakeholders: true
    },
    PortablePersonPage: {
        serverValue: PiReports.PersonSnapshot,
        languages: LanguageAvailabilityByProduct.JobReports,
        reportName: 'portablePersonPage.tabTitle',
        reportFilename: 'reportName.pdf.personSnapshot',
        canEmail: false,
        showSendAssessmentTakers: false,
        showSendStakeholders: false
    },
    RelationshipGuide: {
        serverValue: PiReports.RelationshipGuide,
        languages: LanguageAvailabilityByProduct.Guides,
        canEmail: true,
        reportFilename: 'reportName.pdf.relationshipGuide'
    },
    BehavioralOverview: {
        serverValue: PiReports.BehavioralOverview,
        languages: LanguageAvailabilityByProduct.Guides,
        canEmail: true,
        reportFilename: 'reportName.pdf.behavioralOverview'
    },
    FullBehavioralPattern: {
        serverValue: PiReports.FullBehavioralPattern,
        languages: LanguageAvailabilityByProduct.BehavioralReports,
        canEmail: false,
        reportFilename: 'reportName.pdf.fullBehavioralPattern'
    }
};

export enum JobMatchValue {
    Pending,
    Low,
    Ok,
    Great
}
export enum ReportSteps {
    Options = 1,
    Preview = 2,
    Email = 3
}

// Copied from server
export enum FactorCombinationType {
    Unknown = 0,
    AOverB = 1,
    BOverA = 2,
    AOverC = 3,
    COverA = 4,
    AOverD = 5,
    DOverA = 6,
    BOverC = 7,
    COverB = 8,
    BOverD = 9,
    DOverB = 10,
    COverD = 11,
    DOverC = 12,
    AEqualB = 13,
    AEqualC = 14,
    AEqualD = 15,
    BEqualC = 16,
    BEqualD = 17,
    CEqualD = 18
}

export enum ArchiveState {
    Unknown = 0,
    /// <summary>
    /// Non archived state
    /// </summary>
    NotArchived = 1,
    /// <summary>
    /// Archived state
    /// </summary>
    Archived = 2
}

export enum RangeType {
    CrossesMidpoint = 1,
    SingleZone,
    DoesNotCrossMidpoint
}

// Copied from Server
export enum CombinedFactorRelationship {
    Unknown = 0,
    GreaterThan = 1, /// Factor1 greater than other factor
    LessThan = 2, /// Factor1 less than the other factor
    BothLow = 3, /// Both factor below midpoint
    BothHigh = 4, /// Both factors above midpoint
    Equal = 5 /// Bothfactors equal/at the midpoint
}

// Whether to search based on just email or just name or both
export enum PeopleSearchType {
    All = 1,
    Name,
    Email,
    FirstName,
    LastName,
    SortName
}

export enum Communication {
    Connecting,
    Respecting,
    Persuading,
    Telling
}

export enum BehavioralReportPurpose {
    Select,
    Readback,
    CandidateEvaluation,
    InterviewPreparation,
    Coaching,
    MangerDevelopment,
    RelationshipFostering,
    Other
}

export enum BehavioralReportPurpose2 {
    Select,
    ShortlistTopCandidates,
    CompareCandidateJT,
    DescribeCandidateHM,
    AddCandidateFile,
    ReadbackPrepSelf,
    ReadbackReadDuring,
    ReadbackSupplement,
    Other
}

// NOTE: these names MUST match the server
export enum JobTargetCreationMethod {
    Manual,
    MultipleContributors,
    SingleAssessment,
    BenchmarkProfile
}

/**
 * From Server
 */
export enum FileUploadStatus {
    Unknown = 0,
    ToBeProcessed = 1,
    Processing = 2,
    ProcessingFailed = 3,
    Complete = 4,
    CompleteWithErrors = 5,
    UploadFailed = 6
}

// From Server
export enum FileUploadType {
    Unknown = 0,
    OrgPerson = 1,
    BulkAssessment = 2
}

// Bulk upload assessment API
export enum BulkUploadAssessmentType {
    None = 0,
    Behavioral,
    Cognitive,
    BehavioralAndCognitive
}

export enum UIFileUploadStatus {
    Ready,
    Verification,
    UploadFailure,
    Processing,
    ProcessingError,
    Success
}

/**
 * From Classic Server
 *
 * Surfaced API error codes in the network response
 */
export enum ErrorNumber {
    /**
     * Success, no errors
     */
    Success = 0,
    /**
     * The required criteria is invalid
     */
    RequiredCriteriaInvalid = 1,
    /**
     * The required parameter is missing
     */
    RequiredParameterMissing = 2,
    /**
     * The parameter is out of range
     *
     * The associated resource  is a formatted string that my be updated at runtime
     */
    ParameterOutOfRange = 3,
    /**
     * The parameter must be less than parameter X
     *
     * The associated resource  is a formatted string that my be updated at runtime
     */
    ParameterMustBeLessThanParameterX = 4,
    /**
     * The endpoint is unreachable
     */
    EndpointUnreachable = 5,
    /**
     * The is an internal error
     */
    InternalError = 6,
    /**
     * The entity is not able to be found
     */
    EntityNotFound = 7,
    /**
     * The parameter content is invalid
     */
    ParameterIsInvalid = 8,
    /**
     * The entity is found
     */
    EntityFound = 9,
    /**
     * AdministeredBy info is missing
     */
    ParameterMissing = 10,
    /**
     * ExternalPersonId and AssessmentUserGuid are both specified
     */
    MultipleIdsProvided = 11,
    /**
     * The requested format is not supported
     */
    RequestedFormatIsNotSupported = 12,
    /**
     * The input json is invalid
     */
    InputJSONIsInvalid = 13,
    /**
     * The parameter value is not valid
     *
     * This can happen if parameter is not of the correct type or is not in
     * the correct format and the values are typically dynamic and obtained from another resource.
     */
    GenericParameterIsInvalid = 14,
    /**
     * The language requested is invalid for this resource
     *
     * This can happen if the language provided is not supported or not supported in the context of the resource being accessed
     */
    LanguageRequestedIsInvalid = 15,
    /**
     * The parameter contains invalid ids
     *
     * Typically occurs when the IDs are not found, or not accessible.
     */
    ParameterContainsInvalidIds = 16,
    /**
     * The parameter contains an ID that could not be found
     *
     * Typically occurs when the ID is not found, or not accessible.
     */
    ParameterContainsInvalidId = 17,
    /**
     * There is no position associated with the assessment
     *
     * Typically occurs when the assessment has not be assigned a position.
     */
    NoAssociatedPosition = 18,
    /**
     * The assessment could not be found
     *
     * Typically occurs if the assessment ID provided can't be retrieved.
     */
    AssessmentNotFound = 19,
    /**
     * The position associated with the assessment was not completed
     *
     * Typically occurs if the assessment ID provided has a position that has not been completed
     */
    PositionNotCompleted = 20,
    /**
     * The parameter must be greater than X
     *
     * The associated resource  is a formatted string that my be updated at runtime
     */
    ParameterMustGreaterThanX = 21,
    /**
     * The parameter must be greater than parameter X
     *
     * The associated resource  is a formatted string that my be updated at runtime
     */
    ParameterMustBeGreaterThanParameterX = 22,
    /**
     * Access to the requested entity or operation is denied due to insufficient rights
     *
     * Typically occurs when the calling user does not have the corresponding company in the UserCompanies table
     */
    AccessDenied = 23,
    /**
     * The number of entries exceeded the limit. The limit is [{0}] for the parameter {1}
     *
     * Typically occurs when there are too many input values in an array or list
     */
    LimitExceeded = 24,
    /**
     * The entity identified by the parameter [{0}:{1}] already exists.
     *
     * Typically occurs a user defined identity such as an external id already
     * exists when trying to create a new entity.
     */
    EntityAlreadyExists = 25,
    /**
     * The parameter must not be an empty string. It can be null or a non empty
     * string. A string consisting of only spaces or whitespace characters is
     * considered an empty string.
     *
     * Typically occurs if the user specifies `""` for an external id.
     */
    ParameterMustNotBeAnEmptyString = 26,
    /**
     * The API is down for maintenance
     *
     * Only occurs when the IsUnderMaintenance config setting is true. Used to indicate to the caller that the API is not available
     */
    DownForMaintenance = 27,
    /**
     * The api being access has been retired
     *
     * Occurs when a request to an API has occurred that corresponds to an api that has been retired
     */
    RetiredAPI = 28,
    /**
     * The OData expression is not valid
     *
     * Occurs when OData expression provided contains invalid column names or is malformed.
     */
    ODataExpressionNotValid = 29,
    /**
     * The OData column name [{0}] specified for the $select query option is not supported
     *
     * Occurs when OData a column name for the $select clause is not supported
     */
    ODataSelectQueryOptionError = 30,
    /**
     * The OData column name [{0}] specified for the $filter query option is not supported
     *
     * Occurs when OData a column name for the $filter clause is not supported
     */
    ODataFilterQueryOptionError = 31,
    /**
     * The OData column name [{0}] specified for the $skip query option is not supported
     *
     * Occurs when OData a column name for the $skip clause is not supported
     */
    ODataSkipQueryOptionError = 32,
    /**
     * The OData column name [{0}] specified for the $top query option is not supported
     *
     * Occurs when OData a column name for the $top clause is not supported
     */
    ODataTopQueryOptionError = 33,
    /**
     * The OData column name [{0}] specified for the $orderby query option is not supported
     *
     * Occurs when OData a column name for the $orderby clause is not supported
     */
    ODataOrderByParameterError = 34,
    /**
     * The OData feature is not supported
     *
     * Occurs when OData an odata feature is not supported such as $expand
     */
    ODataFeatureNotSupportedError = 35,
    /**
     * The OData expression can't be interpreted
     *
     * This is a more general error that occurs when OData expression can't be interpreted
     */
    ODataExpressionCantBeInterpreted = 36,
    /**
     * The $select query option contains an invalid property name or is malformed
     *
     * Occurs when OData a column name for the $select clause has invalid characters in it or is malformed in some manner
     */
    ODataSelectQueryOptionMalformedError = 37,
    /**
     * The $filter query option contains an invalid property name or is malformed
     *
     * Occurs when OData a column name for the $filter clause has invalid characters in it or is malformed in some manner
     */
    ODataFilterQueryOptionMalformedError = 38,
    /**
     * The $skip query option contains an invalid property name or is malformed
     *
     * Occurs when OData a column name for the skip clause has invalid characters in it or is malformed in some manner
     */
    ODataSkipQueryOptionMalformedError = 39,
    /**
     * The $top query option contains an invalid property name or is malformed
     *
     * Occurs when OData a column name for the $top clause has invalid characters in it or is malformed in some manner
     */
    ODataTopQueryOptionMalformedError = 40,
    /**
     * The $orderby query option contains an invalid property name or is malformed
     *
     * Occurs when OData a column name for the $orderby clause has invalid characters in it or is malformed in some manner
     */
    ODataOrderByParameterMalformedError = 41,
    /**
     * The $search query option contains an invalid property name or is malformed
     *
     * Occurs when OData a column name for the $search clause has invalid characters in it or is malformed in some manner
     */
    ODataSearchQueryOptionError = 42,
    /**
     * The searchfields query option contains an invalid property name or is malformed
     *
     * Occurs when OData a column name for the searchfields clause has invalid characters in it or is malformed in some manner
     */
    ODataSearchFieldsQueryOptionError = 43,
    /**
     * Duplicate value as this parameter value already exists
     *
     * Occurs when value to be added already exists.
     */
    ParameterValueExists = 44,
    /**
     * Duplicate value as this parameter value already exists
     *
     * Occurs when value to be added already exists.
     */
    UserAlreadyHasInheritedAccess = 45,
    /**
     * Duplicate value as this parameter value already exists
     *
     * Occurs when value to be added already exists.
     */
    UserAlreadyHasDirectAccess = 46,
    /**
     * Resource has conflicting state and action cannot be executed
     *
     * Typically occurs when the action to be executed needs resource in specific state.(Deletion not allowed if active child items)
     */
    ConflictFound = 47,
    /**
     * The MyGroup id provided does not exist
     *
     * Occurs when the MyGroup id provided does not exist
     */
    MyGroupDoesNotExist = 48,
    /**
     * Access to the folder is denied
     *
     * Occurs when the caller specifies a folder they do not have access to.
     */
    AccessToFolderIsDenied = 50,
    /**
     * User name already exists
     *
     * Occurs when trying to set the username to an already existing username.
     */
    UserUsernameExists = 51,
    /**
     * Invalid User name
     *
     * Occurs when trying to set the username to an invalid email.
     */
    InvalidUsername = 52,
    /**
     * Valid Contact Email Needed
     *
     * Occurs when trying to set the username to an invalid email.
     */
    ValidContactEmailNeeded = 53,
    /**
     * Generic Password Error
     *
     * Occurs when you fail to reset a password due to an Auth0 problem.
     */
    PasswordProblem = 54,
    /**
     * Max number of cognitive assessments for email reached
     *
     * Occurs when the maximum number of cognitive assessments has been sent to an email address.
     */
    MaxCognitiveAssessmentsPerEmailReached = 55,
    /**
     * Multiple parameters provided but only one of the provided parameters is allowed at a time.
     *
     * Occurs when multiple parameters are provided but only one of the provided
     * parameters is allowed at a time. An example is FolderPath and FolderId,
     * both were provided but only one of the two is allowed.
     */
    MultipleParametersProvidedOneAllowed = 56,
    /**
     * The set of required parameters was not satisfied, one must be provided
     *
     * Occurs when there is a subset of required parameters where one must be
     * provided but none were. An example is FolderId and FolderPath, one of the
     * two must be provided.
     */
    NoneOfRequiredParametersAreProvided = 57,
    /**
     * The inconsistent data detected
     *
     * Typically happens when search index does not match what is in azure sql.
     */
    InconsistentDataDetected = 58,
    /**
     * There is a serialization error deserializing payload
     *
     * Typically happens when a message or input data is corrupted or malformed
     */
    SerializationError = 59,
    /**
     * The password does not meet password requirements
     */
    PasswordStrengthProblem = 60
}

// From Core Server
// Only the different Error Numbers from Classic
// Surfaced API error codes in the network response
export enum CoreErrorNumber {
    /// <summary>
    /// The assessment has expired and is no longer valid
    /// </summary>
    AssessmentExpired = 51,

    /// <summary>
    /// Assessment has already started and can not be taken
    /// </summary>
    AssessmentAlreadyInProgress = 52,

    /// <summary>
    /// Request does not contain valid authorization
    /// </summary>
    NotAuthorized = 53,

    /// <summary>
    /// The request exceeds the max number for this API
    /// </summary>
    TooManyAPIRequests = 54,

    /// <summary>
    /// Account provisioning cannot continue because the user's email is in use under a diff company
    /// </summary>
    AccountProvisioningUserHasAccess = 100,

    /// <summary>
    /// Account provisioning cannot continue because the user's email has already been registered under another deal
    /// </summary>
    AccountProvisioningAlreadyRegisteredDeal = 101,

    /// <summary>
    /// Cognitive Assessment's time since started has exceeded the assessment's time alloted
    /// </summary>
    AssessmentTimeAllotedExceeded = 102
}

// Sync with AssessmentType enum on assessment site, use when building urls to specific assessments
export enum AssessmentSiteTypes {
    Cognitive = 'cog',
    EmailInviteBehavioral = 'emailba',
    ChecklistBehavioral = 'checklistba',
    StrategyAssessment = 'strategyassessment',
    CandidateBehavioralLink = 'candidateba'
}

export enum OnboardingChecklistRoute {
    InitialLogin = '',
    ConnectBehavioral = '/onboarding/selfidentity',
    InviteEmployeesBA = '/onboarding/assess',
    AddMoreUsers = '/onboarding/addusers',
    DoneState = ''
}

// Sync with The anonymization execution modes on the back end
export enum BulkAnonymizationModes {
    Never = 0,
    Once = 1,
    Recurring = 2
}

// sync to moduleAccessLevel in Core
export enum ModuleAccessLevel {
    Unknown = 0,
    NoAccess = 1,
    BasicAccess = 2,
    CommonAccess = 3
}

// sync to InvitationAnd haringProcessingStatus in pi-useraccess
export enum InvitationAndSharingProcessingStatus {
    Unknown = 0,
    Pending = 1,
    Completed = 2,
    Revoked = 3
}

// sync to ActivityType in pi-useraccess
export enum ActivityType {
    Unknown = 0,
    Invitation = 1,
    Sharing = 2
}

// sync to ValueMetricsProductType in pi-value-metrics
export enum ValueMetricsProductType {
    Unknown = 0,
    Design,
    HireHero,
    Diagnose,
    Hire,
    Inspire,
    Design2,
    Inspire2,
    Diagnose2
}

// sync to ValueMetricsOperationType in pi-value-metrics
export enum ValueMetricsOperationType {
    Unknown = 0,
    Initialize,
    Add,
    Consume,
    Renew,
    Get
}

// sync with TimeTrialCalculationLevel in PI.Accounts.Common.Constants
export enum TimeTrialCalculationLevel {
    Unknown = 0,
    Company,
    User
}

export enum ValueMetricPaywallType {
    Unknown = 0,
    OutOfValueMetrics,
    AvailableValueMetrics,
    ConvertSelfServe,
    SelfServeAvailableValueMetrics
}

// sync to Value metric names in use for each product (formerly constant server-side but no longer as of Q2 2022)
export enum ValueMetricNames {
    Unknown = 'Unknown',
    DesignPrimary = 'Primary',
    InspirePrimary = 'Primary',
    HireCandidateActivation = 'Secondary' // Candidates
}

// sync to PublicIdentifiers.AccountProvisionTriggerSubSource in backend
export enum AccountProvisionTriggerSubSource {
    Unknown = 0,
    PISoftware,
    PIAssessment,
    DesignSelfServeTeamMember,
    DesignTeamMemberHasBA,
    DesignTeamMemberNoBA
}

export enum AccountProvisionReferringSource {
    Unknown = 0,
    PISoftware = 1,
    Salesforce = 2,
    Learn = 3,
    SelfServe = 4,
    Prospect = 5
}

// sync to PublicIdentifiers.CompanyAccountProvisioningProductType in backend
export enum CompanyAccountProvisioningProductType {
    Unknown = 0,
    Design,
    HireHero
}

export enum TeamActionFilters {
    AllActions = 0,
    InProgressActions = 1,
    CompletedActions = 2
}

// sync to ShareableLinkType (currently in Design eventually moving to corelib)
export enum ShareableLinkType {
    Default = 0,
    TeamSummary = 1
}

// Module + Sharing User Enums for requesting changes
export enum UserManagementBatchAction {
    Unknown = 0,
    Create,
    Update,
    Delete,
    Move
}

export enum ModuleUserAccessLevel {
    Unknown = 0,
    NoAccess = 1,
    Limited = 2,
    Full = 3,
    Admin = 4,
    CompanyAdmin = 5
}

export enum EntityUserAccessPolicy {
    Unknown = 0,
    None = 1,
    Read = 2,
    Edit = 3
}

export enum UserAccessSoftwareModule {
    Unknown = 0,
    Hire = 1,
    Design = 2,
    Diagnose = 3,
    Inspire = 4,
    Perform = 5
}

export enum UserAccessEmailType {
    Unknown,
    InviteHire,
    InviteDesign,
    Sharing,
    AddedToTeamTakeBA,
    AddedToTeamExistingBA
}

export enum NavOptions {
    Hire = 'Hire',
    Design = 'Design',
    Diagnose = 'Diagnose',
    Inspire = 'Inspire',
    Perform = 'Perform',
    Admin = 'Admin page'
}

export enum CurrentModuleOptions {
    Hire = 'Hire',
    Design = 'Design',
    Diagnose = 'Diagnose',
    Inspire = 'Inspire',
    Admin = 'Admin page',
    Platform = 'Platform',
    Perform = 'Perform'
}

// Copied from Server
export enum InspireAccessStatus {
    //
    // Summary:
    //     Unknown status
    Unknown,
    //
    // Summary:
    //     Has Access to Inspire and has completed the BA
    HasAccess,
    //
    // Summary:
    //     Pending Access to Inspire, the invite was sent and not accepted or was accepted
    //     but BA wasn't completed
    Pending,
    //
    // Summary:
    //     No Access to Inspire, the invite was not sent
    NoAccess
}

export enum CompanyClassificationType {
    Unknown = 0,
    Client = 1,
    Seller = 2,
    SellerGrantedTrial = 3,
    Workshop = 4,
    DynamicDemo = 5,
    Test = 6,
    LegacyDemoAccount = 7,
    LegacyBusinessAccount = 8
}
